import { useState } from 'react';
import { useSelector } from 'react-redux';
import { PiInfoDuotone } from 'react-icons/pi';
import styles from './index.module.less';
import GlobalTeamSurveyModal from './GlobalTeamSurveyModal';

const GlobalTeamSurveyToast = () => {
  const [surveyModalOpen, setSurveyModalOpen] = useState(false);
  const [surveyToastDismissed, setSurveyToastDismissed] = useState(false);

  const user = useSelector(
    (globalState: any) => globalState.auth.user
  );

  if (!user.survey_due || surveyToastDismissed) return null;

  return (
    <>
      <GlobalTeamSurveyModal
        open={surveyModalOpen}
        onComplete={() => {
          setSurveyToastDismissed(true);
          setSurveyModalOpen(false);
        }}
      />
      <div className={styles.toastWrapper}>
        <div className={styles.toastContent}>
          <PiInfoDuotone className={styles.toastIcon} aria-hidden="true" />

          <span className={styles.toastTitle}>Claim my 10 points</span>

          <div className={styles.toastAction}>
            <button
              type="button"
              onClick={() => setSurveyModalOpen(true)}
              className={styles.toastButton}
            >
              Start
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalTeamSurveyToast;
